// extracted by mini-css-extract-plugin
module.exports = {"pane":"PageMenu_pane__1E352","tabPane":"PageMenu_tabPane__2YLjS","clientMenu":"PageMenu_clientMenu__eqe3b","icon":"PageMenu_icon__2L86s","paneTitle":"PageMenu_paneTitle__18zVS"};